// removed by extract-text-webpack-plugin
module.exports = {"destroyed-page":"missing-event__destroyed-page__I_bEX","destroyed-container":"missing-event__destroyed-container__11ASO","destroyed":"missing-event__destroyed__2ooxc","logo":"missing-event__logo__14oVa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/missing-event.scss
// module id = 1471
// module chunks = 1